import { OutliersDataItem } from 'widgets/outliers/data/outliersData';
import { linearExtentAdjustedForBubble } from 'widgets/outliers/components/chart/series/bubblesSeries';

export const buildBenchmarkPerformanceExtent = (
    dataItems: OutliersDataItem[],
    bubbleMaxPx: number,
    lengthPx: number,
    mirror: boolean
) => {
    return linearExtentAdjustedForBubble(
        dataItems,
        'benchmarkPerformance',
        bubbleMaxPx,
        lengthPx,
        mirror
    );
};
